<z-form-field
    [style.width]="widthSignal()"
    [style.min-height]="heightSignal()"
    class="configurable-dropdown"
>
    @if (labelSignal()) {
        <label z-form-label
            >{{ labelSignal() }}
            @if (requiredSignal()) {
                <span class="configurable-dropdown__required">*</span>
            }
        </label>
    }

    <z-form-control>
        <z-select
            [zValue]="zSelectValue()"
            [zPlaceholder]="placeholderSignal() || ''"
            [zDisabled]="disabledSignal() || control.disabled"
            [zMultiple]="multipleSignal()"
            [zLabel]="displayLabel()"
            [zSelectionTooltip]="multiSelectContactTooltip()"
            [zValueLabelMap]="valueLabelMapForZSelect()"
            [zMaxLabelCount]="multipleSignal() ? 2 : 1"
            [zAppearance]="zSelectAppearanceSignal()"
            [zPanelMaxHeight]="panelMaxHeightSignal() ?? 384"
            [zPanelClass]="panelClassSignal() ?? ''"
            (zSelectionChange)="onZSelectChange($event)"
        >
            @for (option of optionsSignal(); track option.value) {
                <z-select-item
                    [zValue]="'' + option.value"
                    [zDisabled]="!!option.disabled"
                    [zTriggerLabel]="getContactTriggerLabel(option)"
                >
                    @if (option.data && isContactOption(option)) {
                        <div class="configurable-dropdown__contact-option">
                            @if (getContactAvatar(option)) {
                                <img
                                    [src]="getContactAvatar(option)"
                                    [alt]="getContactName(option)"
                                    class="configurable-dropdown__contact-avatar"
                                    onerror="
                                        this.style.display = 'none'
                                        if (this.nextElementSibling)
                                            this.nextElementSibling.style.display = 'flex'
                                    "
                                />
                            }
                            <div
                                class="configurable-dropdown__contact-avatar configurable-dropdown__contact-avatar--placeholder"
                                [style.display]="getContactAvatar(option) ? 'none' : 'flex'"
                            >
                                <app-svg-icon
                                    name="person"
                                    size="sm"
                                    class="configurable-dropdown__contact-avatar-icon"
                                />
                            </div>
                            <div class="configurable-dropdown__contact-info">
                                <div class="configurable-dropdown__contact-name-row">
                                    <span class="configurable-dropdown__contact-name">{{
                                        getContactName(option)
                                    }}</span>
                                    @if (getContactDesignation(option)) {
                                        <span class="configurable-dropdown__contact-designation">
                                            ({{ getContactDesignation(option) }})
                                        </span>
                                    }
                                    @if (isContactPoc(option)) {
                                        <span
                                            class="configurable-dropdown__poc-badge"
                                            [zTooltip]="getPocBadgeTooltip()"
                                        >
                                            {{ getPocBadgeLabel() }}
                                        </span>
                                    }
                                </div>
                                <div class="configurable-dropdown__contact-details">
                                    @if (getContactEmail(option) || getContactPhone(option)) {
                                        <span>
                                            {{ getContactEmailDisplay(option) }}
                                            <span> - </span>
                                            {{ getContactPhoneDisplay(option) }}
                                        </span>
                                    }
                                </div>
                            </div>
                        </div>
                    } @else {
                        {{ option.label }}
                    }
                </z-select-item>
            }

            @if (showEmptyOptionSignal()) {
                <z-select-item zValue="">
                    {{ emptyOptionTextSignal() }}
                </z-select-item>
            }
        </z-select>
    </z-form-control>

    @if (errorMessage?.trim()) {
        <z-form-message zType="error" class="configurable-dropdown__error-msg">{{
            errorMessage
        }}</z-form-message>
    } @else if (!hideErrorMessage && control.invalid && (control.touched || control.dirty)) {
        <z-form-message zType="error" class="configurable-dropdown__error-msg">{{
            getErrorMessage()
        }}</z-form-message>
    }

    @if (hintSignal() && !(control.invalid && control.touched)) {
        <z-form-message>{{ hintSignal() }}</z-form-message>
    }
</z-form-field>
